import apiClient from './config';
import { Festivo } from "../../types/index"
import { CreateFestivoResponse, CreateMultipleFestivosResponse } from "../../types/festivos"



// Servicios para obtener, crear, actualizar y eliminar festivos
export const fetchFestivos = async (): Promise<Festivo[]> => {
    const response = await apiClient.get('/festivos');
    return response.data;
};

// Funcion para crear festivos llamando al endpoint POST /festivos
// P3: la respuesta trae además `impacto` — las clases que ya existían ese día y
// se han cancelado, con las recuperaciones emitidas.
export const createFestivo = async (festivo: Festivo): Promise<CreateFestivoResponse> => {
    const response = await apiClient.post('/festivos', festivo);
    return response.data;
};




// Funcion para crear festivos llamando al endpoint POST /festivos/multiple
//se espera que en el cuerpo de la solicitud sea un array de objetos { fecha, descripcion }
// P3: la respuesta pasó de ser el array pelado a `{ festivos, impacto }`, por el
// recuento de clases canceladas. Los dos repos se promocionan juntos.
export const createMultipleFestivos = async (festivos: Festivo[]): Promise<CreateMultipleFestivosResponse> => {
    const response = await apiClient.post('/festivos/multiple', festivos);
    return response.data;
};




// Funcion para actualizar festivos llamando al endpoint PUT /festivos/:festivoId
export const updateFestivo = async (festivo: Festivo): Promise<Festivo> => {
    const response = await apiClient.put(`/festivo/${festivo._id}`, festivo);
    return response.data;
};




// Funcion para eliminar festivos llamando al endpoint DELETE /festivos/:festivoId
export const deleteFestivo = async (festivoId: string): Promise<void> => {
    await apiClient.delete(`/festivos/${festivoId}`);
};

